import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LawFirm } from '@models/lawFirms';
import { cloneDeep } from 'lodash';

@Component({
	selector: 'app-solicitor',
	templateUrl: './solicitor.component.html',
	standalone: false,
})
export class SolicitorComponent {
	@Input() showClerk = false;
	public _solicitor: LawFirm;

	@Input() set solicitor(solicitor: LawFirm) {
		this._solicitor = cloneDeep(solicitor);
	}

	@Output() onUpdate: EventEmitter<LawFirm> = new EventEmitter<LawFirm>();

	_onUpdate($event) {
		this.onUpdate.emit($event);
	}
}
